import { NgModule } from '@angular/core';
import { CustomMaterialModule } from './material.module';
import { FormaterPipe } from '@pipes/formater/formater.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ResizableModule } from 'angular-resizable-element';
import { FlexLayoutModule } from '@angular/flex-layout';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { SanitizeHtmlPipe } from '@pipes/sanitize/sanitize.pipe';
import { AppHttpInterceptor } from './app-http.inteceptor';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { SignAppService } from '@services/sign.service';
import { MAT_LEGACY_TOOLTIP_DEFAULT_OPTIONS as MAT_TOOLTIP_DEFAULT_OPTIONS, MatLegacyTooltipDefaultOptions as MatTooltipDefaultOptions } from '@angular/material/legacy-tooltip';
import { FormatterModule } from '@pipes/formater/formatter.module';
import { TruncatePipe } from '@pipes/truncate/truncate.pipe';

const TOOLTIP_DEFAULT_OPTIONS: MatTooltipDefaultOptions = {
    showDelay: 500,
    hideDelay: 0,
    touchendHideDelay: 500,
    disableTooltipInteractivity: true
};

@NgModule({
    declarations: [
        SanitizeHtmlPipe,
    ],
    imports: [
        CommonModule,
        CustomMaterialModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        HttpClientJsonpModule,
        NgxSpinnerModule,
        ResizableModule,
        FlexLayoutModule,
        DragDropModule,
        ClipboardModule,
        TruncatePipe,
        FormatterModule
    ],
    exports: [
        CommonModule,
        CustomMaterialModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        HttpClientJsonpModule,
        NgxSpinnerModule,
        ResizableModule,
        FlexLayoutModule,
        DragDropModule,
        FormaterPipe,
        SanitizeHtmlPipe,
        ClipboardModule,
        TruncatePipe,
        FormatterModule
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true },
        { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: TOOLTIP_DEFAULT_OPTIONS },
        SignAppService
    ]
})

export class GlobalModule {
}
